import axios from 'axios'

export default function ProjectitemImportService(formData, projectId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/project/" + projectId + "/items/import",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
}
